import { Button } from '@flixbus/honeycomb-react';
import { Icon, IconCopy } from '@flixbus/honeycomb-icons-react';
import { DateTime } from 'luxon';

import { useVoucher } from '../../context/VoucherProdiver';
import { useNotification } from '../Notifications/Context';

import OverviewDiscountTypeFields from '../VoucherOverview/OverviewDiscountTypeFields';

const CopyVoucher = () => {
  const { data } = useVoucher();
  const { pushToast } = useNotification();

  const fields = OverviewDiscountTypeFields(data.discountType);

  const copyVoucherData = () => {
    navigator.clipboard.writeText(`
      Voucher code: ${data.code}
      Valid from: ${DateTime.fromISO(data.validityInterval.validSince).setLocale('de').toLocaleString()}
      Valid until: ${DateTime.fromISO(data.validityInterval.validUntil).setLocale('de').toLocaleString()}
      Value: ${fields.map(f => (typeof f.value === 'object' ? `${f.value.props.value}${f.value.props.code}` : f.value)).join(', ')}
    `);

    pushToast({ message: 'Copied to clipboard!', status: 'success' });
  };

  return (
    <Button appearance='link' onClick={copyVoucherData}>
      <Icon InlineIcon={IconCopy} />
      Copy
    </Button>
  );
};

export default CopyVoucher;
